module.exports = __webpack_public_path__ + "img/2025-11-17d_2.5a9141f4.jpg";